import { render } from "./Frontend.vue?vue&type=template&id=e63d7b94"
import script from "./Frontend.vue?vue&type=script&lang=js"
export * from "./Frontend.vue?vue&type=script&lang=js"
script.render = render

export default script